<template>
  <v-date-picker
    v-model="internalValue"
    :popover="{ visibility: 'hover-focus' }"
    :masks="{ input: masks, data: masks }"
    :max-date="maxDate"
    class="app-datepicker"
  >
    <template #default="{ inputValue }">
      <AppInput
        v-bind="$attrs"
        :value="inputValue"
        readonly
        class="app-datepicker__input"
      />
    </template>
  </v-date-picker>
</template>

<script>
export default {
  name: "AppDatePicker",

  inheritAttrs: false,

  model: {
    prop: "value",
    event: "change"
  },

  props: {
    value: null,
    format: {
      type: String,
      default: "YYYY-MM-DD"
    },
    maxDate: [Number, Date]
  },

  data() {
    return {
      internalLazyValue: this.value
    };
  },

  computed: {
    masks() {
      return ["L", "YYYY-MM-DD", "YYYY/MM/DD", this.format];
    },
    internalValue: {
      get() {
        return this.$dayjs(this.internalLazyValue, this.format).toDate();
      },
      set(val) {
        val = this.$dayjs(val).format(this.format);

        if (val === this.internalLazyValue) return;
        this.internalLazyValue = val;

        this.$emit("change", val);
      }
    }
  },

  watch: {
    value(val) {
      this.internalLazyValue = val;
    }
  }
};
</script>

<style lang="scss">
.app-datepicker {
  &__input {
    font-weight: inherit;
    font-size: inherit;
    text-decoration: inherit;
    /* height: inherit; */
  }
}
</style>
